import React, { useState } from "react";
import { motion } from "framer-motion";
import ProgramsCard from "./ProgramsCard";

const programs = [
  {
    name: "Career Launcher",
    duration: "3 Months",
    mode: "Online",
    description: "Perfect for beginners starting their tech journey",
    enrolled: 450,
    rating: 4.8,
    badge: "Popular",
    badgeColor: "from-blue-600 to-cyan-600",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&h=250&fit=crop",
    path: "/knowledge/program/6835cdbcadc140f89bca5c32"
  },
  {
    name: "Career Enhancer",
    duration: "4 Months",
    mode: "Online",
    description: "Advance your existing skills to the next level",
    enrolled: 320,
    rating: 4.9,
    badge: "Premium",
    badgeColor: "from-purple-600 to-pink-600",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&h=250&fit=crop",
    path: "/knowledge/program/6a27a298a4078e5f3d8e5fb2"
  },
  {
    name: "Career Explorer",
    duration: "2-6 Months",
    mode: "Flexible",
    description: "Explore multiple career paths with specialized tracks",
    enrolled: 680,
    rating: 4.7,
    badge: "Versatile",
    badgeColor: "from-green-600 to-teal-600",
    image: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=400&h=250&fit=crop",
    path: "/knowledge/program/career-explorer"
    // paths: [
    //   {
    //     title: "Clock Stopper",
    //     path: "/knowledge/program/career-explorer/clock-stopper",
    //     description: "Time management and productivity mastery"
    //   },
    //   {
    //     title: "Hands On Learn",
    //     path: "/knowledge/program/career-explorer/hands-on-learn",
    //     description: "Practical project-based learning approach"
    //   },
    //   {
    //     title: "EmployShield",
    //     path: "/knowledge/program/career-explorer/employ-shield",
    //     description: "Job security and career protection strategies"
    //   }
    // ]
  }
];

const Programs = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const motionProperties = {
    initial: "hidden",
    whileInView: "visible",
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.6, ease: "easeOut" }
  };

  const motionVariantsTop = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0 }
  };

  const motionVariantsLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 }
  };

  const motionVariantsRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 }
  };

  return (
    <div className="w-full h-auto py-8 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col gap-6 justify-center items-center">
          <motion.h1
            variants={motionVariantsTop}
            {...motionProperties}
            className="text-[40px] text-gray-400 font-bold tracking-wider text-center"
          >
            PROGRAMS
          </motion.h1>

          <motion.h2
            variants={motionVariantsTop}
            {...motionProperties}
            className="text-[25px] text-yellow-500 font-bold tracking-wider"
          >
            CHOOSE A PROGRAM THAT FITS YOU
          </motion.h2>

          <div className="lg:w-[80%] w-full">
            <motion.p
              variants={motionVariantsLeft}
              {...motionProperties}
              className="flex text-[15px] text-gray-400 font-medium text-center"
            >
              To ensure you receive the most impactful training and career support, please select the program that best matches your current stage and professional goals: Career Explore, Career Launcher, or Career Enhancer.
            </motion.p>
          </div>
          <div className="lg:w-[80%] w-full">
            <motion.p
              variants={motionVariantsRight}
              {...motionProperties}
              className="flex text-[15px] text-gray-400 font-medium text-center">
              Each track is thoughtfully crafted to address the distinct needs of individuals at different phases of their journey. Your selection enables us to deliver a tailored, results-driven experience—maximizing the value of our training, mentorship, and comprehensive Job Hunting Services Program.
            </motion.p>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center items-center mt-8">
            <div className="text-gray-500">Loading programs...</div>
          </div>
        ) : error ? (
          <div className="flex justify-center items-center mt-8">
            <div className="text-red-500">{error}</div>
          </div>
        ) : (
          <motion.div
            className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 mt-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {programs.map((program, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <ProgramsCard program={program} />
              </motion.div>
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Programs;